// useAccountSelectionSelectors.ts
import { useAppDispatch, useAppSelector } from '@app';
//~ Import the selectors from your slice file
import {
    selectIsAccountSelected,
    selectSelectedAccount,
    selectSelectedAccountId,
    selectSelectedAccountName,
    selectSelectedAccountRights,
    selectSelectedAccountStatus,
    setAccount,
} from '../slices/selectedAccountSlice';
import { useCallback } from 'react';
import { Account } from '../types';

//~ You can also define individual hooks for each selector here

export const useIsAccountSelected = () => {
    return useAppSelector(selectIsAccountSelected);
};

export const useSelectedAccount = () => {
    return useAppSelector(selectSelectedAccount);
};

export const useSelectedAccountId = () => {
    return useAppSelector(selectSelectedAccountId);
};

export const useSelectedAccountName = () => {
    return useAppSelector(selectSelectedAccountName);
};

export const useSelectedAccountRights = () => {
    return useAppSelector(selectSelectedAccountRights);
};

export const useSelectedAccountStatus = () => {
    return useAppSelector(selectSelectedAccountStatus);
};

/**
 * Custom hook to access selectors for the accountSelection slice.
 *
 * @returns An object containing selector functions bound to useSelector.
 */
export const useSelectedAccountSelectors = () => {
    //~ Define selector functions for relevant properties here

    const isAccountSelected = useIsAccountSelected();
    const selectedAccount = useSelectedAccount();

    const selectedAccountId = useSelectedAccountId();
    const selectedAccountName = useSelectedAccountName();
    const selectedAccountRights = useSelectedAccountRights();
    const selectedAccountStatus = useSelectedAccountStatus();

    return {
        //~ Return all the defined selector values here

        isAccountSelected,
        selectedAccount,

        selectedAccountId,
        selectedAccountName,
        selectedAccountRights,
        selectedAccountStatus,
    };
};

export const useSelectAccount = () => {
    const dispatch = useAppDispatch();

    const selectAccount = useCallback(
        (account: Account) => {
            dispatch(setAccount(account));
        },
        [dispatch],
    );

    return { selectAccount };
};
